import { Col } from 'antd';
import React, { useRef } from 'react';
import IntroBlock from 'components/public/Intro/IntroBlock';
import SubscribeForm from 'components/SubscribeForm';
import { FormattedMessage, useIntl } from 'react-intl';
import Pricing from 'components/Pricing';
import ExampleLastIntegration from 'components/public/integrations/overview/ExampleLastIntegration';

// export const OffTheShelve = ({ login }: { login?: boolean }): JSX.Element => {
export const OffTheShelve = (): JSX.Element => {
  const { formatMessage } = useIntl();

  const integrationsRef = useRef<HTMLDivElement>(null);

  return (
    <div>
      <div ref={integrationsRef} className="scroll-margin-top">
        <ExampleLastIntegration type="white" />
      </div>
      <Pricing freeTrailLink={'/hitch/teamleader/shopify'} />

      <IntroBlock
        type="white"
        title={formatMessage({
          defaultMessage: `Can't find what you're looking for?`,
          description: 'off-the-shelve/subscribe/title',
        })}
        description={
          <>
            <Col span={24}>
              <p>
                <FormattedMessage
                  defaultMessage="Let us know, we are always open to support others as well."
                  description="off-the-shelve/subscribe/description"
                />
              </p>
            </Col>
            <Col span={24}>
              <SubscribeForm />
            </Col>
          </>
        }
      />
    </div>
  );
};

export default OffTheShelve;
